<script>
export default {
    name: "Stocklevelperstore",

    data() {

        return {
            itemsstocks: [],
            items: [],
            qtyitems: [],
            stores:[],
            itemtypes:[],
            filter: {
                date: window.moment().format('YYYY-MM-DD'),
                storeId:0,
                itemtypeId:0,
                searchFilter:'',

            },
            userName: this.$root.username,
        };
    },

    mounted () {

        this.fetchAll();
        this. fetchStores();
        this. getItemTypes();
        
    },

    methods: {
        fetchStores() {

return this.$http.get(`Shared/GetStoreLocations`).then(({ data }) => {
    this.stores = data;
}).catch(() => {});
},

        fetchAll () {

            this.$root.loading = true;
            let url=`Inventory/GetItemReorderLl`;
            url += `?StoreId=${this.filter.storeId}`;
            url += `&TypeId=${this.filter.itemtypeId}`;
            url += `&ReorderOption=${this.filter.reorderoption}`;
            url += this.filter.searchFilter ? `&SearchText=${this.filter.searchFilter}` : ``;
               
           this.$accountsHttp.get(url)
                .then(response => { this.itemsstocks = response.data; this.$root.loading = false; })
                .catch(() => { this.$root.loading = false; });
        },
        getItemStockLevel(ItemId,StoreId) {
 
let qtystoreitems=this.itemsstocks.itemsStore.filter(itm => itm.itemID == ItemId && itm.storeID == StoreId);
 qtystoreitems.length
                                        ?
                                       qtystoreitems[0].qty
                                        :
                                        0
 
    },
      getStores() {
            return this.$accountsHttp.get('Shared/Stores').then(response => {
                this.stores = response.data;
            }).catch(() => {});
        },
        getItemTypes() {
            return this.$accountsHttp.get('Shared/ItemTypes').then(response => {
                this.itemtypes = response.data;
            }).catch(() => {});
        },
},
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Stock Reorder Level Report</h5>
                </template>
                <template v-slot:card-body>
                    <div class="flex w-full">
                        <div class="w-1/4 p-tiny">
                            <label for="grid-store-from" class="label-control">Search:</label> <input type="text" v-model.trim="filter.searchFilter"
                     
                    id="grid-search" class="input-control input-sm text-xs">   </div>
                       
                         <div class="w-1/4 p-tiny">
                    <label for="grid-store-from" class="label-control">Store:</label> <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.storeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select store</option>
                            <option v-for="store in stores" 
                                :key="store.id" :value="store.id">{{ store.name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div>
            <div class="md:w-1/4 w-1/2 p-1">
                <label for="grid-store-to" class="label-control">Option:</label>
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from"
                            v-model.trim="filter.reorderoption"
                             class="input-control input-sm text-xs">
                             <option :value="0">Select Option</option>
                             <option :value="1">Below Re-Order Level</option>
                             <option :value="2">Above Re-Order Level</option>
                            <option :value="3">Equals to Re-Order Level</option>
                             
                        </select>
                    </template>
                </tail-select>
                </div>
                  <div class="w-1/4 p-tiny">
                    <label for="grid-store-to" class="label-control">Item Type:</label>
                 <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.itemtypeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select Item Type</option>
                            <option v-for="itemtype in itemtypes" 
                                :key="itemtype.id" :value="itemtype.id">{{ itemtype.type_Name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div>
             <div class="w-1/4 p-tiny pl-2">
                <label for="grid-store-to" class="label-control"> .</label>
                 <button class="btn-sm btn-info text-xs rounded" @click.prevent="fetchAll"><i class="fa fa-filter"></i> Filter</button>
                        </div>
                    </div>
                    <div class="w-full overflow-auto">
                        <table class="table table-hover">
                            <thead class="bg-blue-500 text-xs text-white">
                                <tr class="w-full flex">
                                    <th class="p-tiny w-1/12">ItemId</th>
                                    <th class="p-tiny w-1/4">Item Name</th>
                                    <th class="p-tiny w-1/6">Type</th>
                                    <th class="p-tiny w-1/6">Reorder Level</th>
                                    <th class="p-tiny w-1/6">Stock Level</th>
                                    <th class="p-tiny w-1/6">Variance</th>
                                    
                                     </tr>
                            </thead>
                            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                                <tr class="flex w-full" v-for="(item, idx) in itemsstocks" :key="idx">
                                    <td class="p-tiny w-1/12">{{item.itemID }}</td>
                                    <td class="p-tiny w-1/4">{{ item.itemName}}</td>
                                    <td class="p-tiny w-1/6">{{ item.typeName}}</td>
                                    <td class="p-tiny w-1/6">{{ item.reorderLevel}}</td>
                                    <td class="p-tiny w-1/6">{{ item.stockLevel}}</td>
                                    <td class="p-tiny w-1/6">{{ item.stockLevel-item.reorderLevel}}</td>
                                    
                                     
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
                <template v-slot:card-footer>
                    <div class="w-full text-right">
                      <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                    </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
